import {
  ADD_BOOKING_TEMPLATE_NAME,
  GET_ALL_BOOKING_TEMPLATE_BY_COMPANY_ID,
  GET_ALL_BOOKING_NAME,
  SET_TEMPLATE_HEADER_NAME,
  RESET_REDUX_STATE,
  SET_TEMPLATE_PREVIEW_DATA,
  CLEAR_COMPONENT_PREVIEW_DATA,
  CLEAR_COMPONENT_GRID_LAYOUT_DATA,
  SET_TEMPLATE_GRID_LAYOUT_DATA,
} from "../constants";

const initState = {
  bookingTemplateName: "",
  bookingTemplateList: [],
  bookingTemplateArr: [],
  bookingTemplateHeaderName: '',
  componentPreviewData: [],
  componentGridLayoutData: []
};

const bookingTemplate = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_BOOKING_TEMPLATE_NAME: {
      return {
        ...state,
        bookingTemplateName: payload,
      };
    }
    case GET_ALL_BOOKING_TEMPLATE_BY_COMPANY_ID: {
      return {
        ...state,
        bookingTemplateList: payload,
      };
    }
    case GET_ALL_BOOKING_NAME: {
      return {
        ...state,
        bookingTemplateArr: payload,
      };
    }
    case SET_TEMPLATE_HEADER_NAME: {
      return {
        ...state,
        bookingTemplateHeaderName: payload
      }
    }
    case SET_TEMPLATE_PREVIEW_DATA: {
      return {
        ...state,
        componentPreviewData: payload
      }
    }
    case RESET_REDUX_STATE: {
      return initState
    }

    case CLEAR_COMPONENT_PREVIEW_DATA: {
      return {
        ...state,
        componentPreviewData: []
      }
    }

    case CLEAR_COMPONENT_GRID_LAYOUT_DATA: {
      return {
        ...state,
        componentGridLayoutData: []
      }
    }

    case SET_TEMPLATE_GRID_LAYOUT_DATA: {
      return {
        ...state,
        componentGridLayoutData: payload
      }
    }

    default:
      return state;
  }
};

export default bookingTemplate;
